/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';

/* Internal Imports */
/* Components */

import SliderExperience from '@ieo/Components/SliderExperience';
/* Services */
/* Styles */

/**
 *
 * @param {Object} SectionContent
 *  @param {String} lang
 *  @param {String} region
 * @returns ProgramTestimonial
 */
const ProgramTestimonialV3 = ({
  sectionContent,
  region,
  lang,
  pageData,
  prgData,
}) => {
  return (
    <Box
      background={{
        base: `#00005B`,
        md: `#00005B`,
        lg: ` #00005B`,
        xl: ` #00005B`,
      }}
    >
      <Flex maxW="1330px" flexDir="column" margin={'0 auto'}>
        <Box
          pos={{ base: 'static', md: 'relative' }}
          top="30px"
          // h={{ base: '640px', md: '500px', lg: '520px' }}
        >
          <SliderExperience
            sectionContent={sectionContent?.[0]}
            lang={lang}
            region={region}
            paddingBottom={'50px'}
            heightBase={'auto'}
            color="#fff"
            arrowTop="inherit"
            left="15%"
            right="0%"
            leftForRight="calc(85% - 44px)"
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default ProgramTestimonialV3;
